import "./App.css";
import "./styles/colors.css";
import "./styles/layout.css";
import "./styles/mobile.css";
import "./styles/elements.css";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { JSX, useState } from "react";
import Home from "./pages/home.page";
import FooterComponent from "./components/footer.component";
import { ScrollToTopOnReload } from "./utils/scroll.util";
import HeaderComponent from "./components/header.component";
import NotFound from "./pages/notfound.page";
import Lebenslauf from "./pages/lebenslauf.page";
import Background from "./components/background.component";
import Publikationen from "./pages/publikationen.page";
import Projekte from "./pages/projekte.page";
import Lehre from "./pages/lehre.page";
import Kontakt from "./pages/kontakt.page";
  
function App() {
    const savedLanguage = localStorage.getItem('lang_en');
    const [isEnglish, setIsEnglish] = useState<boolean>(savedLanguage === 'true');

    function layout(
        props: Readonly<{
            page: JSX.Element,
            background?: boolean,
            backgroundSeed?: number,
            footer?: boolean,
            header?: boolean,
            headerAbsolute?: boolean,
        }
    >): JSX.Element {
        const { backgroundSeed, page, background, footer, header, headerAbsolute } = props;
        
        return <>
            <div className="page-container">
                {(header === undefined || header) && <HeaderComponent setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} absolute={!!headerAbsolute} />}
                {
                    background === undefined || background ? <Background seed={backgroundSeed}>
                        {page}
                    </Background> : <>
                        {page}
                    </>
                }
            </div>
            {(footer === undefined || footer) && <FooterComponent setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />}
        </>;
    }

    return (
        <>
            <header>
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" /> {/* Stop IPhone auto-zoom in on input/textfields on select */}
            </header>

            <BrowserRouter>
            
                <ScrollToTopOnReload />
                
                <Routes>
                    <Route path="/" element={layout({ page: <Home setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />, headerAbsolute: true, background: false })} />
                    <Route path="/lebenslauf" element={layout({ page: <Lebenslauf setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} /> })} /> {/* backgroundSeed: 73562 */}
                    <Route path="/publikationen" element={layout({ page: <Publikationen setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} /> })} />
                    <Route path="/projekte" element={layout({ page: <Projekte setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} /> })} />
                    <Route path="/lehre" element={layout({ page: <Lehre setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} /> })} />
                    <Route path="/kontakt" element={layout({ page: <Kontakt setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} /> })} />

                    <Route path="*" element={layout({ page: <NotFound />})} />
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
